import { Award, MonitorDot, UserRound, Settings, TrendingUp, History, Calculator, Smartphone, ArrowUpCircle, ArrowDownCircle, Palette, CreditCard, Wallet, Bell, BarChart3, Banknote, Cog, Code, Coins, Trophy } from "lucide-react";
import { getRoleBasedUrl } from "Routes/allRoutes";
import {
  getRoleFromAccessToken,
  getIsSuperuserFromAccessToken
} from "helpers/jwt";

// Function to generate role-based menu data
const generateMenuData = (role?: string | null) => {
  const baseMenuData: any = [
    {
        label: 'menu',
        isTitle: true,
    },
    
    {
        id: "dashboard",
        label: 'Dashboard',
        link: getRoleBasedUrl("/dashboard", role),
        icon: <MonitorDot />,
    },
    {
        id: "operations",
        label: 'Operations',
        icon: <History />,
        subItems: [
            {
                id: 'operations-players',
                label: 'Players',
                link: '/players',
            },
            {
                id: 'operations-player-app-status',
                label: 'Player App Status',
                link: getRoleBasedUrl('/player-app-status', role),
            },
        ],
    },
    {
        id: "market-section",
        label: 'Market',
        icon: <TrendingUp />,
        subItems: [
            {
                id: 'market-game-list',
                label: 'Game List',
                link: getRoleBasedUrl('/market', role),
            },
            {
                id: 'market-game-rate',
                label: 'Game Rate',
                link: getRoleBasedUrl('/payout-multiplier', role),
            },
            {
                id: 'market-user-bid-history',
                label: 'User Bid History',
                link: getRoleBasedUrl('/bet-history', role),
            },
            {
                id: 'market-winning-history',
                label: 'Declare Results',
                link: getRoleBasedUrl('/declare-result', role),
            },
        ]
    },
    {
        id: "starline",
        label: 'Starline',
        icon: <TrendingUp />,
        subItems: [
            {
                id: 'starline-game-list',
                label: 'Game List',
                link: getRoleBasedUrl('/starline/market', role),
            },
            {
                id: 'starline-game-rate',
                label: 'Game Rate',
                link: getRoleBasedUrl('/payout-multiplier', role),
            },
            {
                id: 'starline-user-bid-history',
                label: 'User Bid History',
                link: getRoleBasedUrl('/starline/bet-history', role),
            },
            {
                id: 'starline-winning-history',
                label: 'Declare Results',
                link: getRoleBasedUrl('/starline/declare-result', role),
            },
        ]
    },
    {
        id: "manage-apps",
        label: 'Manage Apps',
        link: getRoleBasedUrl("/manage-apps", role),
        icon: <Smartphone />,
    },
    {
        id: "referral",
        label: 'Referral',
        link: getRoleBasedUrl("/referral", role),
        icon: <Award />,
    },
    // {
    //     id: "withdraw-history",
    //     label: 'Withdraw History',
    //     link: getRoleBasedUrl("/withdraw-history", role),
    //     icon: <ArrowUpCircle />,
    // },
    {
        id: "wallet",
        label: 'Wallet',
        icon: <Wallet />,
        subItems: [
            {
                id: 'withdraw-request',
                label: 'Withdraw Request',
                link: getRoleBasedUrl('/withdraw-request', role),
            },
            {
                id: 'add-fund',
                label: 'Add Fund',
                link: getRoleBasedUrl('/add-fund', role),
            },
            {
                id: 'deposit-request',
                label: 'Deposit Request',
                link: getRoleBasedUrl('/deposit-request', role),
            },
            {
                id: 'deposit-analytics',
                label: 'Deposit Analytics',
                link: getRoleBasedUrl('/deposit-analytics', role),
            },
        ]
    },
    {
        id: "notifications",
        label: 'Notifications',
        link: getRoleBasedUrl("/notifications", role),
        icon: <Bell />,
    },
    {
        id: "sales-report",
        label: 'Sales Report',
        link: getRoleBasedUrl("/sales-report", role),
        icon: <BarChart3 />,
    },
    {
        id: "referred -users",
        label: 'Referred Users',
        link: getRoleBasedUrl("/referred-users", role),
        icon: <UserRound />,
    },
    {
        id: 'settings',
        label: 'Settings',
        icon: <Settings />,
        subItems: [
            {
                id: 'app-configurations',
                label: 'App Configurations',
                link: getRoleBasedUrl('/app-configurations', role),
            },
            {
                id: 'app-customization',
                label: 'App Customization',
                link: getRoleBasedUrl('/app-customization', role),
            },
            {
                id: 'general-settings',
                label: 'General Settings',
                link: getRoleBasedUrl('/general-settings', role),
            },
            {
                id: 'payment-settings',
                label: 'Payment Settings',
                subItems: [
                    {
                        id: 'manual-payments',
                        label: 'Manual',
                        link: getRoleBasedUrl('/payments/manual', role),
                    },
                    {
                        id: 'api-payments',
                        label: 'API',
                        link: getRoleBasedUrl('/payments/api', role),
                    },
                ]
            },
        ]
    },
    {
        id: 'change-password',
        label: 'Change Password',
        icon: <Settings />,
        link: getRoleBasedUrl('/change-password', role),
    },
    // {
    //     id: "deposit-history",
    //     label: 'Deposit History',
    //     link: "/deposit-history",
    //     icon: <ArrowDownCircle />,
    // },
    {
        id: 'users',
        label: 'Users',
        icon: <UserRound />,
        link: getRoleBasedUrl('/users', role),
    },
    ...(getIsSuperuserFromAccessToken()
      ? [
          {
            id: 'manage-apps',
            label: 'Manage Apps',
            icon: <Smartphone />,
            link: '/manage-apps',
          },
        ]
      : []),

    {
        id: 'role-creation',
        label: 'Role Creation',
        icon: <Award />,
        link: getRoleBasedUrl('/role-creation', role),
    },
    {
        id: 'game-rates',
        label: 'Game Rates',
        icon: <Calculator />,
        link: getRoleBasedUrl('/game-rates', role),
    },
    {
        id: 'bank-details',
        label: 'Bank Details',
        icon: <Banknote />,
        link: getRoleBasedUrl('/bank-details', role),
    },
    
   
    {
        id: 'authentication',
        label: 'Authentication',
        icon: <Award />,
        subItems: [
            {
                id: 'login',
                label: 'Login',
                link: '/login',
            },
            
            {
                id: 'logout',
                label: 'Logout',
                link: '/logout',
            },
        ]
    },
  ];


  // Result Management is available only to Admin and Sub Admin.
  const normalizedResultRole = role ? role.toLowerCase() : '';
  const canManageResults =
    !role ||
    normalizedResultRole === 'admin' ||
    normalizedResultRole === 'sub admin' ||
    normalizedResultRole === 'subadmin' ||
    normalizedResultRole === 'sub_admin' ||
    (
      normalizedResultRole.includes('sub') &&
      normalizedResultRole.includes('admin') &&
      normalizedResultRole !== 'superadmin'
    );

  if (!canManageResults) {
    const resultIndex = baseMenuData.findIndex(
      (item: any) => item.id === 'result-management'
    );

    if (resultIndex !== -1) {
      baseMenuData.splice(resultIndex, 1);
    }
  }

    // Roll Caller: only show Operations, Starline, and Wallet
    if (
      role &&
      (
        role.toLowerCase() === 'roll caller' ||
        role.toLowerCase() === 'roll_caller'
      )
    ) {
      const titleItem =
        baseMenuData.find((item: any) => item.isTitle) ||
        { label: 'menu', isTitle: true };

      const operationsItem = baseMenuData.find(
        (item: any) => item.id === 'operations'
      );

      const starlineItem = baseMenuData.find(
        (item: any) => item.id === 'starline'
      );

      const walletItem = baseMenuData.find(
        (item: any) => item.id === 'wallet'
      );

      if (starlineItem && Array.isArray(starlineItem.subItems)) {
        starlineItem.subItems = starlineItem.subItems.filter(
          (item: any) =>
            item.id === 'starline-game-list' ||
            item.id === 'starline-game-rate' ||
            item.id === 'starline-user-bid-history'
        );
      }

      if (walletItem && Array.isArray(walletItem.subItems)) {
        walletItem.subItems = walletItem.subItems.filter(
          (item: any) =>
            item.id === 'withdraw-request' ||
            item.id === 'add-fund' ||
            item.id === 'deposit-request'
        );
      }

      return [
        titleItem,
        operationsItem,
        starlineItem,
        walletItem,
      ].filter(Boolean);
    }

  // If Super Admin, only show App Configuration, App Customization, Manage Apps, Users, and Authentication menu items
  if (role && role.toLowerCase() === 'superadmin') {
    const titleItem = baseMenuData.find((item: any) => item.isTitle) || { label: 'menu', isTitle: true };
    const appConfigItem = {
      id: 'app-configurations',
      label: 'App Configuration',
      link: getRoleBasedUrl('/app-configurations', role),
      icon: <Cog />,
    };
    const appCustomizationItem = {
      id: 'app-customization',
      label: 'App Customization',
      link: getRoleBasedUrl('/app-customization', role),
      icon: <Palette />,
    };
    const manageAppsItem = baseMenuData.find((item: any) => item.id === 'manage-apps');
    const usersItem = baseMenuData.find((item: any) => item.id === 'users');
    const authenticationItem = baseMenuData.find((item: any) => item.id === 'authentication');
    return [titleItem, appConfigItem, appCustomizationItem, manageAppsItem, usersItem, authenticationItem].filter(Boolean);
  }

  // For Admin role, hide App Customization under Settings, but show App Configuration
  if (role && role.toLowerCase() === 'admin') {
    const settingsItem = (baseMenuData as any[]).find((item: any) => item.id === 'settings');
    if (settingsItem && Array.isArray(settingsItem.subItems)) {
      settingsItem.subItems = settingsItem.subItems.filter(
        (s: any) => s.id !== 'app-customization' // Only hide App Customization, keep App Configuration
      );
    }
    // Add HFCM menu item for Admin role only
    const hfcmItem = {
      id: 'hfcm',
      label: 'HFCM',
      link: getRoleBasedUrl('/hfcm', role),
      icon: <Code />,
    };
    // Insert HFCM after App Customization or before Settings
    const insertAfterId = 'app-customization';
    const idx = baseMenuData.findIndex((i: any) => i.id === insertAfterId);
    if (idx !== -1) {
      baseMenuData.splice(idx + 1, 0, hfcmItem);
    } else {
      // If app-customization not found, insert before Settings
      const settingsIdx = baseMenuData.findIndex((i: any) => i.id === 'settings');
      if (settingsIdx !== -1) {
        baseMenuData.splice(settingsIdx, 0, hfcmItem);
      } else {
        baseMenuData.push(hfcmItem);
      }
    }
  }

  // For Support role, completely hide the Settings menu and Game Rates
  if (role && role.toLowerCase() === 'support') {
    const filtered = (baseMenuData as any[]).filter(
      (item: any) =>
        item.id !== 'settings' &&
        item.id !== 'game-rates' &&
        item.id !== 'operations'
    );
    // Ensure Withdraw History and Deposit History are visible for Support
    const itemsToInsert = [
      {
        id: 'withdraw-history',
        label: 'Withdraw History',
        link: getRoleBasedUrl('/withdraw-history', role),
        icon: <ArrowUpCircle />,
      },
      {
        id: 'deposit-history',
        label: 'Deposit History',
        link: getRoleBasedUrl('/deposit-history', role),
        icon: <ArrowDownCircle />,
      },
    ];
    // Insert after Bet History if present
    const insertAfterId = 'bet-history';
    const idx = filtered.findIndex((i: any) => i.id === insertAfterId);
    if (idx !== -1) {
      filtered.splice(idx + 1, 0, ...itemsToInsert);
    } else {
      filtered.push(...itemsToInsert);
    }
    return filtered;
  }

  // For Sub Admin role, show all Admin menu items except Role Creation
  // Handle variations: "Sub Admin", "SubAdmin", "sub admin", "subadmin", "sub_admin"
  const roleLower = role ? role.toLowerCase() : '';
  if (role && (roleLower === 'sub admin' || roleLower === 'subadmin' || roleLower === 'sub_admin' || (roleLower.includes('sub') && roleLower.includes('admin') && roleLower !== 'superadmin'))) {
    // Start with Admin menu (same as Admin but filter out role-creation)
    const settingsItem = (baseMenuData as any[]).find((item: any) => item.id === 'settings');
    if (settingsItem && Array.isArray(settingsItem.subItems)) {
      settingsItem.subItems = settingsItem.subItems.filter(
        (s: any) => s.id !== 'app-customization' // Only hide App Customization, keep App Configuration
      );
      // For Sub Admin, filter Payment Settings to show only Manual tab, hide API tab
      const paymentSettingsItem = settingsItem.subItems.find((s: any) => s.id === 'payment-settings');
      if (paymentSettingsItem && Array.isArray(paymentSettingsItem.subItems)) {
        paymentSettingsItem.subItems = paymentSettingsItem.subItems.filter(
          (ps: any) => ps.id === 'manual-payments' // Only show Manual, hide API
        );
      }
    }
    // Add HFCM menu item for Sub Admin role (same as Admin)
    const hfcmItem = {
      id: 'hfcm',
      label: 'HFCM',
      link: getRoleBasedUrl('/hfcm', role),
      icon: <Code />,
    };
    // Insert HFCM after App Customization or before Settings
    const insertAfterId = 'app-customization';
    const idx = baseMenuData.findIndex((i: any) => i.id === insertAfterId);
    if (idx !== -1) {
      baseMenuData.splice(idx + 1, 0, hfcmItem);
    } else {
      // If app-customization not found, insert before Settings
      const settingsIdx = baseMenuData.findIndex((i: any) => i.id === 'settings');
      if (settingsIdx !== -1) {
        baseMenuData.splice(settingsIdx, 0, hfcmItem);
      } else {
        baseMenuData.push(hfcmItem);
      }
    }
    // Filter out Role Creation menu item for Sub Admin
    const filtered = (baseMenuData as any[]).filter((item: any) => item.id !== 'role-creation');
    return filtered;
  }

  // For Agent (internal), hide the Settings menu, Users menu item, Role Creation menu item, and Game Rates menu item
  if (role && role.toLowerCase() === 'agent (internal)') {
    const filtered = (baseMenuData as any[]).filter(
      (item: any) =>
        item.id !== 'settings' &&
        item.id !== 'users' &&
        item.id !== 'role-creation' &&
        item.id !== 'game-rates' &&
        item.id !== 'operations'
    );
    // Inject Create User menu (Agent-only)
    const createUserItem = {
      id: 'create-user',
      label: 'Create User',
      link: getRoleBasedUrl('/create-user', role),
      icon: <UserRound />,
    };
    // Place it after 'referred -users' if present, else append at end
    const insertAfterId = 'referred -users';
    const idx = filtered.findIndex((i: any) => i.id === insertAfterId);
    if (idx !== -1) {
      filtered.splice(idx + 1, 0, createUserItem);
    } else {
      filtered.push(createUserItem);
    }
    return filtered;
  }

  return baseMenuData;
};

// Export the function and also a default menu data for backward compatibility
const menuData = generateMenuData();

export { generateMenuData, menuData };